import { Checkbox, createFilterOptions, TextField } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import {
    CIRCULATION_SPEED_TYPE, PARAMETER,
    PROFIL,
    REQUEST_PASS_STATUS,
    REQUEST_PASS_TYPE,
    TRJT_TYPE,
} from '../../../constants/enum';
import Radio from '@mui/material/Radio';
import MyButton from '../../Layout/MyButton';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect, useState } from 'react';
import MySelect from '../../Layout/MySelect';
import MyComboBox from '../../Layout/MyComboBox';
import ConfigConvoiComponent from './StepComponents/ConfigConvoiComponent';
import { useDispatch, useSelector } from 'react-redux';
import { loadCaracConvoi, updateCaracConvoi, updateReference } from '../../../actions/RequestPassAction';
import ControlledTextField from '../../Controlled/RequestPass/ControlledTextField';

const filter = createFilterOptions();

const StepCaractConvoi = (props) => {
    const {
        refs,
        profil,
        demandePassageStyle,
        demandePassage,
        reference,
        complementIdentite,
        caracConvoi,
        notAbleToChange,
        handleChangeCheckBox,
        validSteps,
        onNextStep,
        setOpenAlertModal,
        trajetDescr,
        natureChargeOptions,
    } = props;
    const dispatch = useDispatch();
    const editable = validSteps.step3 && (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.CLIENT) || notAbleToChange;

    const configBtnEditable = validSteps.step3 && (profil.profil === PROFIL.INTERVENANT || profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.CLIENT);
    const configurations = caracConvoi.configurations;

    const [nbConfig, setNbConfig] = useState(configurations.length || 1);

    useEffect(() => {
        handleChange('configurations', configurations);
        setNbConfig(configurations.length);
    }, [configurations]);

    useEffect(() => {
        handleChange('nbRames', Math.ceil(caracConvoi.nbVehicule / 10));
    }, [caracConvoi.nbVehicule]);

    const displayMilitary = reference?.typeDemande === REQUEST_PASS_TYPE.SUPERIEUR ? 'true' : (trajetDescr.descr.some((trajet) => trajet.passType === REQUEST_PASS_TYPE.SUPERIEUR || trajetDescr.type === TRJT_TYPE.ALLER_RETOUR && trajetDescr.descrRetour.some((trajet) => trajet.passType === REQUEST_PASS_TYPE.SUPERIEUR)));

    const filterOptions = (options, params) => {
        const filtered = filter(options, params);

        if (params.inputValue !== '') {
            filtered.push(params.inputValue);
        }

        return filtered;
    };

    const handleNbConfigChange = (value) => {
        if (value) {
            if (value >= 20) {
                setNbConfig(20);
                value = 20;
            } else if (value <= 0)
                setNbConfig(1);
            else
                setNbConfig(value);

            updateConfigurations(value);
        }
    };

    const updateConfigurations = (value) => {
        let currentConfigurations = [...configurations];
        let count = value - configurations.length;

        // Si count est supérieure à zéro, on doit ajouter de nouvelles configurations
        if (count > 0) {
            for (let i = 1; i <= count; i++) {
                currentConfigurations.push({
                    index: i + configurations.length,
                    chargeMaxiEssieu: null,
                    distanceMiniInterEssieu: null,
                    validation: 1,
                });
            }
        }

        // Si count est inférieure à zéro, on doit retirer les dernières configurations
        if (count < 0) {
            let count = configurations.length - value;
            for (let i = 1; i <= Math.abs(count); i++) {
                currentConfigurations.pop();
            }
        }

        handleChange('configurations', currentConfigurations);
    };

    const handleChange = (name, value) => {
        dispatch(updateCaracConvoi(name, value));
        if (name === 'masseTotaleCharge') {
            if (value < 48000 && reference?.typeDemande === REQUEST_PASS_TYPE.SUPERIEUR)
                setOpenAlertModal(true);
        }
    };

    return (
        <div ref={(divRef) => refs.current['step-caract_convoi'] = divRef} className='step'>
            <div className='step-content'>
                <div className='step-content-row'>
                    <h3 className='modal-step-title'>Caractéristiques du convoi</h3>

                    <div className='row' style={{
                        flexWrap: 'wrap',
                        justifyContent: 'left',
                        alignItems: 'center',
                        overflow: 'none',
                        maxHeight: '100px',
                    }}>
                        <MyComboBox
                            id={'nature-charge'}
                            name={'natureCharge'}
                            label={'NAT. CONVOI / CHARGEMENT'}
                            disableClass={false}
                            style={{ minWidth: '266px', width: 'auto', marginRight: '30px' }}
                            displayLabel={false}
                            options={natureChargeOptions}
                            value={caracConvoi.natureCharge}
                            setter={(e) => handleChange('natureCharge', e)}
                            disabled={editable}
                            filterOptions={filterOptions}
                        />
                        {reference?.typeDemande === REQUEST_PASS_TYPE.AUTOROUTE &&
                            <>
                                <FormControl
                                    style={{
                                        margin: '20px',
                                        marginLeft: '50px',
                                        marginRight: '10px',
                                        minWidth: '266px',
                                        width: 'auto',
                                    }}>
                                    <FormLabel>Vitesse de circulation</FormLabel>
                                    <RadioGroup row name='vitesseCircuCharge' value={caracConvoi.vitesseCircuCharge}
                                                onChange={(e) => handleChange(e.target.name, e.target.value)}>
                                        <FormControlLabel value={CIRCULATION_SPEED_TYPE.SUP_TO_50} control={<Radio />}
                                                          label='> à 50 km/h'
                                                          disabled={editable} />
                                        <FormControlLabel value={CIRCULATION_SPEED_TYPE.INF_TO_50} control={<Radio />}
                                                          label='< à 50 km/h'
                                                          disabled={editable} />
                                    </RadioGroup>
                                </FormControl>
                            </>
                        }

                        {(reference?.typeDemande === REQUEST_PASS_TYPE.AUTOROUTE && (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.INTERVENANT)) &&
                            <>
                                <FormControl style={{ margin: '20px' }}>
                                    <FormControlLabel control={<Checkbox
                                        value={caracConvoi.accompagnement}
                                        name={'accompagnement'}
                                        onChange={(e) => handleChange(e.target.name, !!!caracConvoi.accompagnement)}
                                        checked={caracConvoi.accompagnement === true}
                                    />} label='Nécessite un accompagnement' />
                                </FormControl>
                            </>
                        }

                        {complementIdentite.military === 'false' &&
                            <MySelect labelClass={'select-label-black'}
                                      name={'category'}
                                      label={'Catégorie'}
                                      disableClass={true}
                                      style={{ minWidth: '150px' }}
                                      displayLabel={true}
                                      datas={['1', '2', '3']}
                                      value={caracConvoi.category}
                                      disabled={editable}
                                      handleChange={(e) => handleChange(e.target.name, e.target.value)}
                            />
                        }
                    </div>

                    <h4 style={{ margin: '20px 20px 0 20px' }}>Caractéristiques maximales du convoi à vide</h4>
                    <div className='row'
                         style={{
                             flexDirection: 'row',
                             flexWrap: 'wrap',
                             justifyContent: 'left',
                             maxHeight: '150px',
                             overflow: 'none',
                         }}>
                        <ControlledTextField
                            label='MASSE TOTALE ROULANTE (EN KG)'
                            type='text'
                            name='masseTotaleVide'
                            value={caracConvoi.masseTotaleVide || ''}
                            style={{ ...demandePassageStyle.textField, width: 'auto', flexGrow: 1 }}
                            autoComplete='off'
                            onChange={(e) => handleChange(e.target.name, e.target.value)}
                            inputProps={{ maxLength: 6 }}
                            disabled={editable}
                            pattern={'^[0-9]*$'}
                        />
                        <ControlledTextField
                            label='LONGUEUR (EN MM)'
                            type='text'
                            name='longueurVide'
                            value={caracConvoi.longueurVide || ''}
                            style={{ ...demandePassageStyle.textField, width: 'auto', flexGrow: 1 }}
                            autoComplete='off'
                            onChange={(e) => handleChange(e.target.name, e.target.value)}
                            inputProps={{ maxLength: 6 }}
                            disabled={editable}
                            pattern={'^[0-9]*$'}
                        />
                        <ControlledTextField
                            label='LARGEUR (EN MM)'
                            type='text'
                            name='largeurVide'
                            value={caracConvoi.largeurVide || ''}
                            style={{ ...demandePassageStyle.textField, width: 'auto', flexGrow: 1 }}
                            autoComplete='off'
                            onChange={(e) => handleChange(e.target.name, e.target.value)}
                            inputProps={{ maxLength: 6 }}
                            disabled={editable}
                            pattern={'^[0-9]*$'}
                        />
                        <ControlledTextField
                            label='HAUTEUR (EN MM)'
                            type='text'
                            name='hauteurVide'
                            value={caracConvoi.hauteurVide || ''}
                            style={{ ...demandePassageStyle.textField, width: 'auto', flexGrow: 1 }}
                            autoComplete='off'
                            onChange={(e) => handleChange(e.target.name, e.target.value)}
                            inputProps={{ maxLength: 6 }}
                            disabled={editable}
                            pattern={'^[0-9]*$'}
                        />
                    </div>

                    <h4 style={{ margin: '20px 20px 0 20px' }}>Caractéristiques maximales du convoi en charge</h4>
                    <div className='row'
                         style={{
                             flexDirection: 'row',
                             flexWrap: 'wrap',
                             justifyContent: 'left',
                             maxHeight: '100px',
                             overflow: 'none',
                         }}>
                        <ControlledTextField
                            label='MASSE TOTALE ROULANTE (EN KG)'
                            type='text'
                            name='masseTotaleCharge'
                            value={caracConvoi.masseTotaleCharge || ''}
                            style={{ ...demandePassageStyle.textField, width: 'auto', flexGrow: 1 }}
                            autoComplete='off'
                            onChange={(e) => handleChange(e.target.name, e.target.value)}
                            inputProps={{ maxLength: 6 }}
                            disabled={editable}
                            pattern={'^[0-9]*$'}
                        />
                        <ControlledTextField
                            label='LONGUEUR (EN MM)'
                            type='text'
                            name='longueurCharge'
                            value={caracConvoi.longueurCharge || ''}
                            style={{ ...demandePassageStyle.textField, width: 'auto', flexGrow: 1 }}
                            autoComplete='off'
                            onChange={(e) => handleChange(e.target.name, e.target.value)}
                            inputProps={{ maxLength: 6 }}
                            disabled={editable}
                            pattern={'^[0-9]*$'}
                        />
                        <ControlledTextField
                            label='LARGEUR (EN MM)'
                            type='text'
                            name='largeurCharge'
                            value={caracConvoi.largeurCharge || ''}
                            style={{ ...demandePassageStyle.textField, width: 'auto', flexGrow: 1 }}
                            autoComplete='off'
                            onChange={(e) => handleChange(e.target.name, e.target.value)}
                            inputProps={{ maxLength: 6 }}
                            disabled={editable}
                            pattern={'^[0-9]*$'}
                        />
                        <ControlledTextField
                            label='HAUTEUR (EN MM)'
                            type='text'
                            name='hauteurCharge'
                            value={caracConvoi.hauteurCharge || ''}
                            style={{ ...demandePassageStyle.textField, width: 'auto', flexGrow: 1 }}
                            autoComplete='off'
                            onChange={(e) => handleChange(e.target.name, e.target.value)}
                            inputProps={{ maxLength: 6 }}
                            disabled={editable}
                            pattern={'^[0-9]*$'}
                        />
                    </div>

                    <h3 className='modal-step-title'>Configurations</h3>
                    {/* region militaire */}
                    {(complementIdentite.military === 'true') &&
                        <div style={{
                            width: 'auto',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                        }}>
                            <FormControl style={{
                                width: 'auto',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                            }}>
                                <FormLabel>Nb Véhicules</FormLabel>
                                <ControlledTextField
                                    label={null}
                                    type='text'
                                    name='nbVehicule'
                                    value={caracConvoi.nbVehicule || ''}
                                    style={{ ...demandePassageStyle.textField, width: 'auto', flexGrow: 1 }}
                                    autoComplete='off'
                                    onChange={(e) => handleChange(e.target.name, e.target.value)}
                                    pattern={'^[0-9]*$'}
                                    inputProps={{ maxLength: 6 }}
                                    disabled={editable}
                                />
                            </FormControl>

                            <FormControl style={{
                                width: 'auto',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                            }}>
                                <FormLabel>Dont</FormLabel>
                                <ControlledTextField
                                    label={null}
                                    type='text'
                                    name='nbTransExcept'
                                    value={caracConvoi.nbTransExcept || ''}
                                    style={{ ...demandePassageStyle.textField, width: 'auto', flexGrow: 1 }}
                                    autoComplete='off'
                                    onChange={(e) => handleChange(e.target.name, e.target.value)}
                                    pattern={'^[0-9]*$'}
                                    inputProps={{ maxLength: 6 }}
                                    disabled={editable}
                                />
                                <FormLabel>transport(s) exceptionnel(s)</FormLabel>
                            </FormControl>

                            <FormControl style={{
                                width: 'auto',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                            }}>
                                <FormLabel>Soit</FormLabel>
                                <ControlledTextField
                                    label={null}
                                    type='text'
                                    name='nbRames'
                                    value={caracConvoi.nbRames || ''}
                                    style={{ ...demandePassageStyle.textField, width: 'auto', flexGrow: 1 }}
                                    autoComplete='off'
                                    onChange={(e) => handleChange(e.target.name, e.target.value)}
                                    pattern={'^[0-9]*$'}
                                    inputProps={{ maxLength: 6 }}
                                    disabled={editable}
                                />
                                <FormLabel>rames</FormLabel>
                            </FormControl>
                        </div>
                    }
                    {/* endregion */}

                    {/* region non militaire */}
                    {((complementIdentite.military === null || complementIdentite.military === 'false') || (displayMilitary && complementIdentite.military === 'true')) &&
                        <>
                            <FormControl style={{
                                width: 'auto',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                            }}>
                                <FormLabel>Nb de configurations</FormLabel>
                                <TextField
                                    label={null}
                                    type='number'
                                    name='nbConfig'
                                    value={nbConfig}
                                    style={{ ...demandePassageStyle.textField, width: '60px' }}
                                    autoComplete='off'
                                    onChange={(e) => handleNbConfigChange(e.target.value)}
                                    inputProps={{ maxLength: 2, min: '1', max: '20' }}
                                    disabled={editable}
                                />
                            </FormControl>
                            <div className={'carac-convoi-configuration-container'}>
                                {configurations && configurations.map((config, index) => (
                                    <ConfigConvoiComponent
                                        profil={profil}
                                        demandePassage={demandePassage}
                                        index={index}
                                        editable={editable}
                                        config={config}
                                        caracConvoi={caracConvoi}
                                        handleChange={handleChange}
                                        demandePassageStyle={demandePassageStyle}
                                        configBtnEditable={configBtnEditable}
                                    />
                                ))}
                            </div>
                        </>}
                    {/* endregion */}

                </div>
                {(profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE) && demandePassage.id !== 0 &&
                    <div className='row' style={{ justifyContent: 'flex-end', alignItems: 'center', height: '80px' }}>
                        <MyButton
                            style={validSteps['step3'] ? 'buttonRejected' : 'buttonValidation'}
                            label={validSteps['step3'] ? 'Rejeter l\'étape' : 'Valider l\'étape'}
                            icon={validSteps['step3'] ? faXmark : faCheck}
                            onClick={() => {
                                onNextStep(null, null, 3);
                            }}
                        />
                    </div>
                }
            </div>
        </div>);
};

export default StepCaractConvoi;